import React from 'react';
import classNames from 'classnames';
import { isMissingTranslation, translate } from '@utils/i18n';
import { Text } from '../../../../../../ui/atoms/Text/Text';
import './ComplianceSectionStyles.scss';
const BASE_CLASS = 'ai-chat-compliance';
const I18N_NAMESPACE = 'features.ai_chat_widget.compliance';
const TERMS_OF_SERVICE_URL = 'https://www.inspectpoint.com/terms-of-service/';
const HOW_TO_USE_DEFAULT_LABEL = 'How to use IP Assistant';
// A host with no translation for the key gets a placeholder back (the namespaced key, or
// i18n-js's `[missing "..."]`), so fall back to English rather than render it.
function howToUseLabel() {
    const label = translate('how_to_use', { namespace: I18N_NAMESPACE });
    return isMissingTranslation(label, `${I18N_NAMESPACE}.how_to_use`) ? HOW_TO_USE_DEFAULT_LABEL : label;
}
export function ComplianceSection({ onHowToUse, isHowToUseDisabled = false }) {
    return (React.createElement("div", { className: classNames(BASE_CLASS, { [`${BASE_CLASS}--with-how-to`]: onHowToUse }) },
        React.createElement(Text, { variant: "body", as: "p", className: `${BASE_CLASS}__text` }, "AI-generated content may contain errors. Always verify important information."),
        React.createElement("div", { className: `${BASE_CLASS}__links` },
            React.createElement(Text, { variant: "link-paragraph", as: "a", href: TERMS_OF_SERVICE_URL, target: "_blank", rel: "noopener noreferrer", className: `${BASE_CLASS}__terms` }, "Terms of Service"),
            onHowToUse && (React.createElement(React.Fragment, null,
                React.createElement("span", { className: `${BASE_CLASS}__separator`, "aria-hidden": "true" }, "|"),
                React.createElement(Text, { variant: "link-paragraph", as: "button", type: "button", className: `${BASE_CLASS}__how-to`, disabled: isHowToUseDisabled, onClick: onHowToUse }, howToUseLabel()))))));
}
